import React, { useEffect, useState } from 'react'
import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs';
import moment from 'moment';
import { BarndImg, LoginPageImg } from '../../static/constant/imgConstants';
import { FiSearch } from 'react-icons/fi';
import Popup from '../../components/popups/Popup/Popup';
import { useDispatch } from 'react-redux';
import { getWalletTxnWithFilter, getWalletTxnWithFilterReset } from '../../store/influencerCampaignStore/actions/InfluencerCampaignActions/getWalletTxnWithFilterActions';
import { addMoneyToWallet } from '../../store/influencerCampaignStore/actions/InfluencerCampaignActions/addMoneyToWalletActions';
import { useLocation, useNavigate } from 'react-router';
import { txnStatus } from '../../store/influencerCampaignStore/actions/InfluencerCampaignActions/txnStatusActions';
import { getUserInfo } from '../../store/authStore/actions/authActions/getUserInfoActions';
import { BsCopy } from 'react-icons/bs';
import { useToast } from '../../hooks/useToast';
import { payment_redirect_uri, payment_redirect_uri_agency } from '../../store/constants';
import DataTable from 'react-data-table-component';
import Footer from '../../components/common/Footer/Footer';
import { useSelector } from 'react-redux';
import { getWalletTxnWithFilterForAgency } from '../../store/agencyStore/actions/getWalletTxnWithFilterForAgencyActions';
import BrandFilterBar from '../../components/common/BrandFilterBar/BrandFilterBar';

const TransactionCard = ({ transaction, onViewReceipt }) => (
    <div className="bg-white rounded-lg shadow-md p-4 mb-4 border border-gray-300">
        <div className="flex flex-col space-y-3">
            {/* Transaction Description */}
            <div>
                <span className="text-[1.6rem] font-bold">{transaction.description}</span>
                <hr className="mt-2 border-t border-gray-300" />
            </div>

            {/* Date */}
            <div className="flex items-center">
                <span className="text-[1.4rem] font-bold w-32">Date:</span>
                <span className="text-[1.4rem]">
                    {moment.utc(transaction.txnDate.split("+")[0]).local().format("DD-MM-YYYY hh:mm A")}
                </span>
            </div>

            {/* Brand Name */}
            <div className="flex items-center">
                <span className="text-[1.4rem] font-bold w-32">Brand Name:</span>
                <span className="text-[1.4rem]">{transaction.brandName}</span>
            </div>

            {/* Amount */}
            <div className="flex items-center">
                <span className="text-[1.4rem] font-bold w-32">Amount:</span>
                <span className="text-[1.4rem]">${transaction.amount}</span>
            </div>

            {/* Transaction Type */}
            <div className="flex items-center">
                <span className="text-[1.4rem] font-bold w-32">Txn Type:</span>
                <span className="text-[1.4rem]">{transaction.transactionType}</span>
            </div>

            {/* Balance */}
            <div className="flex items-center">
                <span className="text-[1.4rem] font-bold w-32">Balance:</span>
                <span className="text-[1.4rem]">${transaction.balance}</span>
            </div>
        </div>
    </div>
);

const BrandWalletAndTransactions = () => {
    const dispatch = useDispatch()
    const Toast = useToast()

    const location = useLocation();
    const navigate = useNavigate();

    const [sessionId, setSessionId] = useState(null);

    const [isPopupOpen, setPopupOpen] = useState(false);
    const [receiptPopupOpen, setReceiptPopupOpen] = useState(false);
    const [getWalletTxnWithFilterResponse, setGetWalletTxnWithFilterResponse] = useState();
    const [getWalletTxnWithFilterResponseOriginal, setGetWalletTxnWithFilterResponseOriginal] = useState();
    const [enteredAmount, setEnteredAmount] = useState(0);
    const [transactionDetails, setTransactionDetails] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [isMobile, setIsMobile] = useState(false);

    const getUserInfoReducer = useSelector(state => state.getUserInfoReducer);

    const breadcrumbData = [
        { label: 'Home', href: '/brand' },
        { label: 'Brand Wallet and Transactions', href: '#' },
    ];

    const columns = [
        {
            name: 'Transaction',
            selector: row => row.description,
            sortable: true,
            style: {
                width: '10rem',
            },
            wrap: true,
        },
        {
            name: 'Date',
            selector: row => moment.utc(row.txnDate.split("+")[0]).local().format("DD-MM-YYYY hh:mm A"),
            sortable: true,
            style: {
                width: '10rem',  // Adjust the width as needed
            },
            wrap: true,
        },
        {
            name: 'Brand Name',
            selector: row => row.brandName,
            sortable: true,
            style: {
                width: '10rem',  // Adjust the width as needed
            },
            wrap: true,
        },
        {
            name: 'Amount',
            selector: row => (
                <span
                // className={`inline-block px-3 py-1 rounded-full text-center ${getStatusStyle(row.campaignStatus)}`}
                >
                    ${row.amount}
                </span>
            ),
            style: {
                width: '10rem',  // Set a smaller width for this column
            },
        },
        {
            name: 'Txn Type',
            selector: row => row.transactionType,
            style: {
                width: '10rem',  // Adjust the width for consistency
            },
        },
        {
            name: 'Balance',
            selector: row => (
                <span
                // className={`inline-block px-3 py-1 rounded-full text-center ${getStatusStyle(row.campaignStatus)}`}
                >
                    ${row.balance}
                </span>
            ),
            style: {
                width: '10rem',
            },
        },
    ];

    const customTableStyles = {
        table: {
            style: {
                position: 'relative',
            },
        },
        headRow: {
            style: {
                backgroundColor: '#F1F4F9',
                minHeight: '52px',
                fontWeight: 700,
                borderRadius: '0.4rem',
                borderBottom: 'none',
                // position: 'fixed',
                top: 0,
            },
            denseStyle: {
                minHeight: '32px',
            },
        },
        rows: {
            style: {
                fontSize: '1.4rem',  // Increased text size for rows
                fontWeight: 600,
                color: '#202224',
                borderBottom: '1px solid #EDEFF1',
                minHeight: '70px',
            },
            denseStyle: {
                minHeight: '40px',
            },
        },
        headCells: {
            style: {
                padding: '1rem',
                fontSize: '1.6rem',
                textAlign: 'left',
            },
        },
        cells: {
            style: {
                padding: '1.5rem',
            },
        },
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    useEffect(() => {
        if (searchQuery === '') {
            setGetWalletTxnWithFilterResponse(getWalletTxnWithFilterResponseOriginal);
        } else {
            const filtered = getWalletTxnWithFilterResponseOriginal?.filter(campaign =>
                campaign.description?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
                campaign.transactionType?.toLowerCase().includes(searchQuery?.toLowerCase())
            );
            setGetWalletTxnWithFilterResponse(filtered);
        }
    }, [searchQuery, getWalletTxnWithFilterResponseOriginal]);

    const handleCopy = async (text) => {
        try {
            await navigator.clipboard.writeText(text); // Copy text to clipboard
            Toast('Copied to clipboard!', 'success'); // Set success message
        } catch (err) {
            Toast('Failed to copy', 'error'); // Error handling
        }
    };

    const handleFilter = (brandId) => {
        console.log("brandId", brandId);
        dispatch(getWalletTxnWithFilterForAgency({
            "fromDate": "",
            "toDate": "",
            brandId: brandId ? brandId : ""
        }, (status, response, message) => {
            if (status === 200) {

                const sorted = [...response].sort((a, b) => {
                    const dateA = new Date(a.txnDate).getTime(); // Convert to timestamp
                    const dateB = new Date(b.txnDate).getTime(); // Convert to timestamp
                    return dateB - dateA; // Sort in descending order
                });

                setGetWalletTxnWithFilterResponse(sorted);
                setGetWalletTxnWithFilterResponseOriginal(sorted);
                dispatch(getWalletTxnWithFilterReset());
            } else if (status) {
                setGetWalletTxnWithFilterResponse([]);
                setGetWalletTxnWithFilterResponseOriginal([]);
                dispatch(getWalletTxnWithFilterReset());
            }
        }));
    };

    const handleReset = () => {
        dispatch(getWalletTxnWithFilterForAgency({
            "fromDate": "",
            "toDate": "",
            brandId: ""
        }, (status, response, message) => {
            if (status === 200) {

                const sorted = [...response].sort((a, b) => {
                    const dateA = new Date(a.txnDate).getTime(); // Convert to timestamp
                    const dateB = new Date(b.txnDate).getTime(); // Convert to timestamp
                    return dateB - dateA; // Sort in descending order
                });

                setGetWalletTxnWithFilterResponse(sorted);
                setGetWalletTxnWithFilterResponseOriginal(sorted);
                dispatch(getWalletTxnWithFilterReset());
            } else if (status) {
                setGetWalletTxnWithFilterResponse([]);
                setGetWalletTxnWithFilterResponseOriginal([]);
                dispatch(getWalletTxnWithFilterReset());
            }
        }));
    };

    useEffect(() => {
        const checkIfMobile = () => {
            setIsMobile(window.innerWidth < 768); // Standard breakpoint for tablets
        };

        // Set initial value
        checkIfMobile();

        // Add event listener for window resize
        window.addEventListener('resize', checkIfMobile);

        // Clean up on unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);

    useEffect(() => {
        if (getUserInfoReducer?.data?.userType === "AGENCY") {
            dispatch(getWalletTxnWithFilterForAgency({
                "fromDate": "",
                "toDate": ""
            }, (status, response, message) => {
                if (status === 200) {

                    const sorted = [...response].sort((a, b) => {
                        const dateA = new Date(a.txnDate).getTime(); // Convert to timestamp
                        const dateB = new Date(b.txnDate).getTime(); // Convert to timestamp
                        return dateB - dateA; // Sort in descending order
                    });

                    setGetWalletTxnWithFilterResponse(sorted);
                    setGetWalletTxnWithFilterResponseOriginal(sorted);
                    dispatch(getWalletTxnWithFilterReset());
                } else if (status) {
                    setGetWalletTxnWithFilterResponse([]);
                    setGetWalletTxnWithFilterResponseOriginal([]);
                    dispatch(getWalletTxnWithFilterReset());
                }
            }));
        } else {
            dispatch(getWalletTxnWithFilter({
                "fromDate": "",
                "toDate": ""
            }, (status, response, message) => {
                if (status === 200) {

                    const sorted = [...response].sort((a, b) => {
                        const dateA = new Date(a.txnDate).getTime(); // Convert to timestamp
                        const dateB = new Date(b.txnDate).getTime(); // Convert to timestamp
                        return dateB - dateA; // Sort in descending order
                    });

                    setGetWalletTxnWithFilterResponse(sorted);
                    setGetWalletTxnWithFilterResponseOriginal(sorted);
                    dispatch(getWalletTxnWithFilterReset());
                } else if (status) {
                    setGetWalletTxnWithFilterResponse([]);
                    setGetWalletTxnWithFilterResponseOriginal([]);
                    dispatch(getWalletTxnWithFilterReset());
                }
            }));
        }
        dispatch(getUserInfo());
    }, [transactionDetails]);


    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const sessionIdFromUrl = params.get('sessionId');
        const paymentStatusFromUrl = params.get('paymentStatus');

        console.log("Session ID:::", sessionIdFromUrl);
        console.log("Payment Status:", paymentStatusFromUrl);

        if (sessionIdFromUrl) {
            setSessionId(sessionIdFromUrl);

            if (paymentStatusFromUrl === 'success') {
                console.log('Payment was successful!');
            } else if (paymentStatusFromUrl === 'failed') {
                console.log('Payment failed or was canceled.');
            }

            dispatch(txnStatus({
                "sessionId": sessionIdFromUrl,
                "status": paymentStatusFromUrl
            }, (status, response, message) => {
                if (status === 200) {
                    setTransactionDetails(response);

                    // Send complete data to parent window
                    if (window.opener) {
                        window.opener.postMessage({
                            txnPaymentCompleted: true,
                            transactionDetails: response
                        }, "*");
                        window.close();
                    }
                    // Populate transaction details and open receipt popup
                    setReceiptPopupOpen(true);
                } else if (status) {
                    console.error('Failed to fetch transaction status:', message);
                }
            }));
        }
    }, [location.search, dispatch, navigate]);


    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data?.txnPaymentCompleted) {
                console.log("Payment completed, updating user info");
                if (event.data.transactionDetails) {
                    setTransactionDetails(event.data.transactionDetails);
                    setReceiptPopupOpen(true);
                }
                dispatch(getUserInfo());
                // Remove the listener after successful dispatch
                window.removeEventListener("message", handleMessage);
            }
        };

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, [dispatch]);

    return (
        <div className="w-full h-full flex flex-col overflow-auto bg-[#F2F3F7]">
            <Breadcrumbs breadcrumbs={breadcrumbData} />
            <div className="w-full flex justify-between items-center  py-8 px-[4rem]">
                <div className="flex items-center">
                    <span className="text-[1.6rem] font-semibold">Brand Wallet and Transactions</span>
                </div>
                <div className="flex items-center">
                    <div className="relative px-[4rem]">
                        <FiSearch
                            className="absolute top-1/2 left-20 transform -translate-y-1/2 w-[2.1rem] h-[2.1rem] text-gray-400" />
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={handleSearchChange}
                            placeholder="Search Transactions"
                            className="w-[20rem] p-3 border text-[1.4rem] inter-font font-[400] border-gray-300 rounded-[0.3rem] pl-16 outline-none"
                        />
                    </div>
                    {getUserInfoReducer?.data?.agencyRoleName !== 'Viewer' &&
                        <div className=" py-1.5 cursor-pointer" onClick={() => {
                            setEnteredAmount(0);
                            setPopupOpen(true);
                        }}>
                            <img src={BarndImg.wallet} alt="" className="mx-auto w-[4.8rem] h-[4.8rem]" />
                            <div className="text-[1.4rem] text-[#202224]">
                                Add Money
                            </div>
                        </div>
                    }
                </div>
            </div>
            {getUserInfoReducer?.data?.userType === 'AGENCY' &&
                <div className="px-[4rem] my-2 h-[12rem]">
                    <BrandFilterBar
                        onFilter={handleFilter}
                        onReset={handleReset}
                    />
                </div>
            }
            {/* Content List Table */}
            <div className="px-[4rem] w-full">
                <div className="w-full h-full flex flex-col rounded-[2.6rem] bg-[#ffffff]">
                    {/* Sticky Header Section */}
                    <div className="sticky top-0 z-10 bg-[#ffffff] mb-2 p-[2.8rem]">
                        <h2 className="text-[2.4rem] inter-font font-[700]">Transaction History</h2>
                    </div>

                    {/* Table Container */}
                    <div className="w-full max-h-[50rem] overflow-y-auto no-scrollbar px-[2.4rem] pb-[2.4rem]">
                        {Array.isArray(getWalletTxnWithFilterResponse) && getWalletTxnWithFilterResponse?.length > 0 ? (
                            isMobile ? (
                                // Mobile view - Cards
                                <div className="flex flex-col space-y-4">
                                    {getWalletTxnWithFilterResponse.map((transaction, index) => (
                                        <TransactionCard
                                            key={index}
                                            transaction={transaction}
                                            onViewReceipt={(transaction) => {
                                                setTransactionDetails(transaction);
                                                setReceiptPopupOpen(true);
                                            }}
                                        />
                                    ))}
                                </div>
                            ) : (
                                // Desktop view - Table
                                <DataTable
                                    columns={columns}
                                    data={getWalletTxnWithFilterResponse}
                                    customStyles={customTableStyles}
                                    pagination
                                    highlightOnHover
                                    striped
                                    responsive
                                />
                            )
                        ) : (
                            <div className="text-4xl leading-[70px] text-gray-500 text-center mt-4">
                                No Transactions Found.
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Add Money Popup */}
            <Popup
                isOpen={isPopupOpen}
                onClose={() => setPopupOpen(false)}
                title="Add Money Into Wallet"
                canDismiss={false}
                icon={<img src={BarndImg.wallet} alt="" className="w-[5.1rem] h-[5.1rem] my-[2rem]" />}
                content={
                    <div className="">
                        <label className="text-[#111729] text-[1.4rem] mb-4">
                            Enter Digits
                        </label>
                        <input
                            type="text"
                            className="w-full px-4 py-4 text-[1.4rem] border border-gray-300 rounded-lg focus:outline-none "
                            value={enteredAmount}
                            maxLength={6}
                            onChange={(e) => {
                                const value = e.target.value;
                                let numericValue = value.replace(/[^0-9]/g, '');
                                numericValue = numericValue.replace(/^0+/, '');
                                setEnteredAmount(numericValue === '' ? '0' : numericValue);
                            }}
                        />
                    </div>
                }
                size="sm"
                primaryButton={{
                    text: 'Add Money',
                    onClick: () => {
                        if (enteredAmount == 0) {
                            Toast("Please enter Amount")
                        } else if (enteredAmount > 999999) {
                            Toast("Amount should be less than 999999");
                        } else {
                            dispatch(addMoneyToWallet({
                                "amount": enteredAmount,
                                "successUrl": getUserInfoReducer?.data?.userType === 'AGENCY' ? `${payment_redirect_uri_agency}success` : `${payment_redirect_uri}success`,
                                "cancelUrl": getUserInfoReducer?.data?.userType === 'AGENCY' ? `${payment_redirect_uri_agency}failed` : `${payment_redirect_uri}failed`
                            }, (status, response, message) => {
                                if (status === 200) {
                                    // window.open(response?.url, "_self");
                                    window.open(response?.url, "_blank", "width=800,height=600,resizable,scrollbars,status");
                                } else if (status) {
                                    Toast(message, "error");
                                }
                            }))
                            setEnteredAmount(0);
                            setPopupOpen(false);
                        }
                    },
                }}
                secondaryButton={{
                    text: 'Cancel',
                    onClick: () => {
                        setEnteredAmount(0);
                        setPopupOpen(false);
                    },
                }}
            />

            {/* Receipt Popup */}
            <Popup
                isOpen={receiptPopupOpen}
                onClose={() => setReceiptPopupOpen(false)}
                title="Transaction Receipt"
                canDismiss
                content={
                    transactionDetails ? (
                        <div className="w-full p-4">
                            {/* Logo and Header */}
                            <div className="flex items-center justify-between mb-6 border-b pb-4">
                                <div>
                                    <img src={LoginPageImg.login1} alt="Brand Logo" className="w-[40%] h-[40%]" />
                                </div>
                                <div className="text-right">
                                    <h2 className="text-xl font-bold text-gray-800">Transaction Receipt</h2>
                                    <p className="text-[1.4rem] text-gray-500">Thank you for your transaction!</p>
                                </div>
                            </div>

                            {/* Transaction Details */}
                            <div className="flex flex-col gap-4 mb-6">
                                <div className="flex justify-start items-center">
                                    <div className='w-[60%]'>
                                        <h3
                                            className="text-[1.4rem] font-semibold text-gray-500 flex justify-start items-center cursor-pointer"
                                            onClick={() => handleCopy(transactionDetails.orderId)}
                                        >
                                            Order ID:
                                            <BsCopy className="ml-[1rem]" />
                                        </h3>
                                        <p className="text-[1.4rem] text-gray-800 max-w-[400px] break-words">
                                            {transactionDetails.orderId}
                                        </p>

                                    </div>
                                    <div className='w-[30%]'>
                                        <h3
                                            className="text-[1.4rem] font-semibold text-gray-500 flex justify-start items-center cursor-pointer"
                                            onClick={() => handleCopy(transactionDetails.referenceNumber)}
                                        >
                                            Reference Number:
                                            <BsCopy className="ml-[1rem]" />
                                        </h3>
                                        <p className="text-[1.4rem] text-gray-800">{transactionDetails.referenceNumber}</p>
                                    </div>
                                </div>
                                <div className="flex justify-start items-center">
                                    <div className='w-[60%]'>
                                        <h3 className="text-[1.4rem] font-semibold text-gray-500">Transaction Date:</h3>
                                        <p className="text-[1.4rem] text-gray-800">{moment(transactionDetails.transactionDate).format('DD-MM-YYYY hh:mm A')}</p>
                                    </div>
                                    <div className='w-[30%]'>
                                        <h3 className="text-[1.4rem] font-semibold text-gray-500">Status:</h3>
                                        <p className={`text-[1.4rem] ${transactionDetails.status == 'SUCCESS' ? 'text-green-600' : 'text-red-600'}`}>
                                            {transactionDetails.status}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Amount Details */}
                            <div className="bg-gray-100 p-4 rounded-md">
                                <h3 className="text-[1.4rem] font-semibold text-gray-500">Amount:</h3>
                                <p className="text-[1.6rem] font-bold text-gray-800">${transactionDetails.amount}</p>
                            </div>

                            {/* Footer */}
                            <div className="mt-6 text-center text-[1.4rem] text-gray-500 border-t pt-4">
                                <p>If you have any questions about this transaction, please contact our support
                                    team.</p>
                            </div>
                        </div>
                    ) : (
                        <p>Loading transaction details...</p>
                    )
                }
                size="md"
            />
            <Footer />

        </div>
    );
};

export default BrandWalletAndTransactions;
